export default {"src":"/_next/static/media/flor_de_loto.cf214fc9.svg","height":17,"width":21,"blurWidth":0,"blurHeight":0};